/**
 * tw-slideshow - Custom slideshow with autoplay and navigation
 */
(function () {
  function initTwSlideshow(section) {
    if (!section) return;
    if (section._twSlideshow) return; // prevent double-init

    var list = section.querySelector('[data-tw-slideshow-list]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tw-slide]'));
    var prevBtn = section.querySelector('[data-tw-slide-prev]');
    var nextBtn = section.querySelector('[data-tw-slide-next]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-tw-dot]'));

    if (!list || slides.length <= 1) return;

    var total = slides.length;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var isPaused = false;

    function updateDots() {
      dots.forEach(function (btn, i) {
        if (i === index) {
          btn.setAttribute('aria-current', 'slide');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    function goTo(i, animate) {
      if (typeof animate === 'undefined') animate = true;
      index = ((i % total) + total) % total;

      if (!animate) {
        list.style.transition = 'none';
        list.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        // force reflow then restore transition
        // eslint-disable-next-line no-unused-expressions
        list.offsetHeight;
        list.style.transition = '';
      } else {
        list.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
      }
      updateDots();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || isPaused || total <= 1) return;
      timer = setInterval(next, speed);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    function handleMouseEnter() {
      isPaused = true;
      stopAutoplay();
    }

    function handleMouseLeave() {
      isPaused = false;
      startAutoplay();
    }

    function handleVisibility() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    // Named handlers so we can detach them in destroy()
    function onPrevClick(e) { e.preventDefault(); prev(); restartAutoplay(); }
    function onNextClick(e) { e.preventDefault(); next(); restartAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
    if (nextBtn) nextBtn.addEventListener('click', onNextClick);

    var dotHandlers = [];
    dots.forEach(function (btn, i) {
      var handler = function (e) {
        e.preventDefault();
        goTo(i);
        restartAutoplay();
      };
      dotHandlers.push(handler);
      btn.addEventListener('click', handler);
    });

    // Basic touch swipe support for mobile
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var touchActive = false;

    function onTouchStart(e) {
      if (!e.touches || e.touches.length !== 1) return;
      touchActive = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      handleMouseEnter();
    }
    function onTouchMove(e) {
      if (!touchActive || !e.touches || e.touches.length !== 1) return;
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    }
    function onTouchEnd() {
      if (!touchActive) return;
      touchActive = false;
      var dx = touchEndX - touchStartX;
      var dy = touchEndY - touchStartY;
      // only treat as swipe if mostly horizontal & past threshold
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next(); else prev();
        restartAutoplay();
      }
      handleMouseLeave();
      touchEndX = touchStartX;
      touchEndY = touchStartY;
    }

    section.addEventListener('mouseenter', handleMouseEnter);
    section.addEventListener('mouseleave', handleMouseLeave);
    section.addEventListener('focusin', handleMouseEnter);
    section.addEventListener('focusout', handleMouseLeave);
    section.addEventListener('touchstart', onTouchStart, { passive: true });
    section.addEventListener('touchmove', onTouchMove, { passive: true });
    section.addEventListener('touchend', onTouchEnd);
    document.addEventListener('visibilitychange', handleVisibility);

    goTo(0, false);
    startAutoplay();

    section._twSlideshow = {
      goTo: goTo,
      destroy: function () {
        stopAutoplay();
        if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
        if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
        dots.forEach(function (btn, i) {
          btn.removeEventListener('click', dotHandlers[i]);
        });
        section.removeEventListener('mouseenter', handleMouseEnter);
        section.removeEventListener('mouseleave', handleMouseLeave);
        section.removeEventListener('focusin', handleMouseEnter);
        section.removeEventListener('focusout', handleMouseLeave);
        section.removeEventListener('touchstart', onTouchStart);
        section.removeEventListener('touchmove', onTouchMove);
        section.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('visibilitychange', handleVisibility);
        delete section._twSlideshow;
      }
    };
  }

  function initAllSlideshows(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tw-slideshow]').forEach(function (section) {
      initTwSlideshow(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSlideshows(document);
    });
  } else {
    initAllSlideshows(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.matches('[data-tw-slideshow]')
      ? e.target
      : e.target.querySelector('[data-tw-slideshow]');
    if (section) initTwSlideshow(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.matches('[data-tw-slideshow]')
      ? e.target
      : e.target.querySelector('[data-tw-slideshow]');
    if (section && section._twSlideshow) section._twSlideshow.destroy();
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAllSlideshows(document);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-tw-slide]');
    var section = e.target.closest('[data-tw-slideshow]');
    if (!slide || !section || !section._twSlideshow) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tw-slide]'));
    var idx = slides.indexOf(slide);
    if (idx > -1) {
      section._twSlideshow.goTo(idx);
    }
  });
})();
